/*----------------------
    PUNTOS DE VENTA
---------------------- */
Pos = {
    init: function () {
        if (!$(".section-pos").length) return;

        $(".pos-item").on("click", function () {
            var index = $(this).data("key");

            $(".pos-item").removeClass("active");
            $(".pos__iframe-item").removeClass("active");

            $(this).addClass("active");
            $('.pos__iframe-item.item--' + index).addClass("active");

            if ($(window).width() < 768) {
                $('html, body').animate({
                    scrollTop: $('.pos__iframe-item.item--' + index).offset().top - $(".section-header").outerHeight() - 80
                }, 800);
            }
        });
    },
};

$(document).ready(function () {
    Pos.init();
});
